import CryptoJS from 'crypto-js';

const KEY = process.env.REACT_APP_STORAGE_ENCRYPTION_KEY!;

if (!KEY) {
  throw new Error('REACT_APP_STORAGE_ENCRYPTION_KEY must be set in the environment');
}

/**
 * Encrypt a JSON object using AES-256.
 * @param jsonObject The JSON object to encrypt.
 * @returns A string of the form `iv:cipherText` in hex.
 */
export function encryptJsonObject(jsonObject: Record<string, unknown>): string {
  const iv = CryptoJS.lib.WordArray.random(16);

  const jsonString = JSON.stringify(jsonObject);

  const encrypted = CryptoJS.AES.encrypt(jsonString, CryptoJS.enc.Hex.parse(KEY), {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return iv.toString() + ':' + encrypted.toString();
}

/**
 * Decrypt a cipher text into a JSON object using AES-256.
 * @param encryptedText The string of the form `iv:cipherText`.
 * @returns The original JSON object.
 */
export function decryptJsonObject(encryptedText: string): Record<string, unknown> {
  if (!encryptedText.includes(':')) throw new Error('Invalid encrypted text format');

  const [ivHex, cipherText] = encryptedText.split(':');

  try {
    const decrypted = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Hex.parse(KEY), {
      iv: CryptoJS.enc.Hex.parse(ivHex),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);

    return JSON.parse(jsonString);
  } catch (error: unknown) {
    throw new Error(`Failed to decrypt JSON object: ${encryptedText}`);
  }
}
